import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper, { cleanCollisions } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import * as COLORS from '../utils/colorUtils'

import { color as d3_color } from 'd3-color'
import { extent as d3_extent } from 'd3-array'
import {
  curveLinear as d3_curveLinear,
  line as d3_line,
  curveLinearClosed as d3_curveLinearClosed,
  lineRadial as d3_lineRadial,
} from 'd3-shape'

import SizeHelper from '../chart_helpers/SizeHelper'
import {
  drawSvgCircle,
  drawSvgPlus,
  drawSvgPolygon,
  drawSvgSquare,
  drawSvgStar,
  drawSvgTriangle,
} from '../utils/shapeUtils'
import { isDarkMode } from '../utils/configUtils'
import { ACCESSIBILITY_OPTIONS_KEYS } from '../utils/accessibilityUtils'
export default class ParallelCoordsChart extends BaseChart {
  constructor(...args) {
    super(...args)
  }
  static defaultConfig = {
    /**
     * {-EN-} Show/hide the data points that form each line.
     * {-ES-} Muestra/oculta los puntos de datos que forman cada línea.
     */
    showPoints: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    /**
     * {-EN-} Define the data point size that form each line.
     * {-ES-} Define el tamaño los puntos de datos que forman cada línea.
     */
    pointsSize: {
      type: [Number, String],
      default: 3,
      options: ['hidden', 3, 6, 9],
      exposed: true,
    },
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    AxisHelper: {
      zoom: {
        nonEditable: true,
      },
      scroll: {
        default: false,
        exposed: true,
      },
      showScrollbar: {
        default: true,
        exposed: true,
      },
      x: {
        scale: 'point',
        getExtent: function (data) {
          return data[0] ? Object.keys(data[0].dimensions).map(d => d) : []
        },
      },
      y: {
        scale: {
          value: ['linear'],
          multiValueIds: 'data.dimensions',
        },
        getExtent: function (data, dimLabel, dimId) {
          // console.log("data,dim",data,dimLabel)
          let extent = d3_extent(data.reduce((res, d) => res.concat(d.dimensions[dimLabel]), []))
          let yDims = this.getYAxesIds()
          if (this.getUnit(dimId[0]) && this.getUnit(dimId[0])[yDims.indexOf(dimId)]) {
            extent = cleanCollisions(
              this.axes[dimId],
              extent,
              [{ value: extent.map(e => ({ value: e })) }],
              1.01
            )
          }
          return extent
        },
        valueFormat: {
          value: ['[N]0'],
          multiValueIds: 'data.dimensions',
        },
        unit: {
          value: [false],
          multiValueIds: 'data.dimensions',
        },
        dimensions: 'data.dimensions',
      },
    },
    TooltipBehavior: {
      getHtml: function (d) {
        let yDims = this.getYAxesIds()
        let yDimNames = this.getYAxesLabels()
        let onAxis = yDims[yDimNames.indexOf(d.id)]
        return `
        <div class="tip-value important">${this.formatTooltipValue(d.value, onAxis)}</div>
        <div class="tip-id">
          <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
            { id: d.parentId }
          )}; margin-right: 3px"></span>
          ${d.parentId}
        </div>
        <div class="secondary">${d.id}</div>
        `
      },
    },
    LegendBehavior: {
      icon: 'line',
    },
    /*
     * {-EN-} Highlight an specific point by id
     * {-ES-} Resalta un punto específico por id.
     */
    highlightedPoint: {
      type: [String, Number, null],
      default: null,
      exposed: true,
    },
    highlightedPointSize: {
      type: Number,
      default: 8,
      exposed: true,
    },
    highlightedPointStroke: {
      type: Number,
      default: 3,
      exposed: true,
    },
    highlightedNodeLines: {
      type: [String, Number],
      default: 'all',
      exposed: true,
    },
    highlightNodeOnClick: {
      type: Boolean,
      default: false,
      exposed: true,
    },
  }
  static helpers = [
    RootHelper,
    ItemsHelper,
    SelectableHelper,
    SizeHelper,
    AxisHelper,
    // {
    //   class: AxisHelper,
    //   config: {
    //     x:{
    //       scale: 'point',
    //       getExtent: function (data){
    //         return data[0] ? Object.keys(data[0].dimensions).map((d)=>d) : []
    //       }
    //     },
    //     y:{
    //       scale:{
    //         value: ['linear'],
    //         multiValueIds: 'data.dimensions'
    //       },
    //       getExtent: function(data,dimLabel,dimId){
    //         // console.log("data,dim",data,dimLabel)
    //         let extent = d3_extent(data.reduce((res,d)=>res.concat(d.dimensions[dimLabel]),[]))
    //         let yDims = this.getYAxesIds()
    //         if(this.getUnit(dimId[0]) && this.getUnit(dimId[0])[yDims.indexOf(dimId)]){
    //           extent = cleanCollisions(this.axes[dimId], extent, [{value:extent.map((e)=>({value:e}))}],1.01)
    //         }
    //         return extent
    //       },
    //       valueFormat: {
    //         value: ['[N]0'],
    //         multiValueIds: 'data.dimensions'
    //       },
    //       unit: {
    //         value: [false],
    //         multiValueIds: 'data.dimensions'
    //       },
    //       dimensions: 'data.dimensions'
    //     },
    //   }
    // },
  ]
  checkConsistency() {
    return true
  }
  setSelectedFunc(sel, d) {
    if (!this.axes.x) {
      // let c = d3_color(this.color(d));
      // c.opacity = 0.4
      // sel.select('path').attr('fill',c+'')
      sel.select('path').attr('fill', this.color(d))
      sel.select('path').attr('fill-opacity', 0.4)
    }
  }
  unsetSelectedFunc(sel) {
    if (!this.axes.x) {
      // sel.select('path').attr('fill','rgba(0,0,0,0)')
      sel.select('path').attr('fill', 'none')
      sel.select('path').attr('fill-opacity', 0)
    }
  }
  draw() {
    let dimsIds = this.data[0] ? Object.keys(this.data[0].dimensions).map((d, i) => 'y_' + i) : []
    let dimsNames = this.data[0] ? Object.keys(this.data[0].dimensions).map(d => d) : []
    let line
    let getValues
    let getPos
    if (this.axes.x) {
      getValues = (dim, value, i) => {
        return [this.axes.x.func.scale()(dim), this.axes[dimsIds[i]].func.scale()(value)]
      }
      getPos = ([x, y]) => {
        return [x, y]
      }
      line = d => {
        return d3_line().curve(d3_curveLinear)(
          dimsNames.map((dim, i) => {
            // return [this.axes.x.scale(dim), this.axes[dimsIds[i]].scale(d.dimensions[dim])]
            return getValues(dim, d.dimensions[dim], i)
          })
        )
      }
    } else {
      getValues = (dim, value, i) => {
        return [(i / dimsIds.length) * 2 * Math.PI, this.axes[dimsIds[i]].func.scale()(value)]
      }
      getPos = ([angle, radius]) => {
        return [Math.cos(angle - Math.PI / 2) * radius, Math.sin(angle - Math.PI / 2) * radius]
      }
      line = d => {
        return d3_lineRadial().curve(d3_curveLinearClosed)(
          dimsNames.map((dim, i) => {
            // return [(i / dimsIds.length) * 2*Math.PI, this.axes[dimsIds[i]].scale(d.dimensions[dim])]
            return getValues(dim, d.dimensions[dim], i)
          })
        )
      }
    }
    this.parentItemsEnter.append('path').attr('fill', 'none').attr('pointer-events', 'none')

    let self = this
    this.parentItemsEnter
      .select('path')
      .attr('d', d => line(d))
      // .attr('fill','rgba(0,0,0,0)')
      .attr('stroke', d => this.color(d))
      .attr('stroke-width', d => this.thickness(d))
      // .attr('stroke-dasharray',(d)=>this.strokeDasharray(d))
      .each(function () {
        this._totalLength = this.getTotalLength()
      })
      .attr('stroke-dasharray', function (d) {
        var dashing = self.strokeDasharray(d)
        if (dashing === 'none') dashing = '1 0'
        var dashLength = dashing
          .split(/[\s,]/)
          .map(function (a) {
            return parseFloat(a) || 0
          })
          .reduce(function (a, b) {
            return a + b
          })
        var dashCount = Math.ceil(this._totalLength / dashLength)
        var newDashes = new Array(dashCount).join(dashing + ' ')
        var dashArray = newDashes + ' 0, ' + this._totalLength
        return dashArray
      })
      .attr('stroke-dashoffset', function () {
        return this._totalLength
      })

    this.parentItemsEnterTrans.select('path').attr('stroke-dashoffset', 0)

    this.parentItemsTrans
      .select('path')
      .attr('d', d => line(d))
      .attr('stroke', d => this.color(d))
      .attr('stroke-dasharray', d => this.strokeDasharray(d))
      .attr('stroke-width', d => this.thickness(d))

    // let self = this
    let items = this.items.merge(this.itemsEnter)

    let breakpoints = items
      .raise()
      .selectAll('.break-point')
      .data(d => {
        return this.config.pointsSize !== 'hidden' ? [null] : []
      })

    breakpoints.exit().remove()
    let breakpointsEnter = breakpoints.enter().append('g').attr('class', 'break-point')
    breakpoints = breakpoints.merge(breakpointsEnter)

    items.select('.break-point').attr('transform', function (d, i) {
      let pos = getPos(getValues(d.id, d.value, i))
      return `translate(${pos[0]},${pos[1]})`
      // return `translate(${self.axes.x.scale(d.id)},${self.axes[dimsIds[i]].scale(d.value)})`
    })

    const getPointType = d => {
      if (
        !this.config.ItemsHelper.colorDict ||
        !this.config.ItemsHelper.colorDict[d.parentId]?.shape
      )
        return 'circle'
      return this.config.ItemsHelper.colorDict[d.parentId].shape
    }

    const isDotHighlighted = d => {
      const interactivityHighlightedNode =
        this.config.highlightNodeOnClick &&
        this._interactiveHighlightedNodes?.[d?.parentId]?.toString() === d?.id.toString()
      return (
        interactivityHighlightedNode ||
        (!this.config.highlightNodeOnClick &&
          (this.config.highlightedNodeLines === 'all' ||
            this.config.highlightedNodeLines === d.parentId) &&
          this.config.highlightedPoint &&
          d?.id.toString() === this.config.highlightedPoint.toString())
      )
    }

    const drawShapes = (className, shapeType, drawEnterCb, drawMergeCb) => {
      let shapes = breakpoints.selectAll(`.${className}`).data(
        d =>
          (isDotHighlighted(d) && getPointType(d) === shapeType) ||
          (this.config.showPoints &&
            this.config.pointsSize !== 0 &&
            this.config.pointsSize !== 'hidden' &&
            getPointType(d) === shapeType)
            ? [d]
            : [],
        d => d.id
      )

      const shapesEnter = shapes
        .enter()
        .append('g')
        .attr('class', `point-shape ${className}`)
        .attr('stroke-width', 0)
      shapesEnter.call(drawEnterCb)
      shapes.exit().transition().duration(800).style('opacity', 0).remove()
      shapes = shapes.merge(shapesEnter)
      shapes
        .attr(
          'fill',
          !isDarkMode(this.config, this._parent.accessibilityOptions)
            ? COLORS.SKIN_BACKGROUND
            : COLORS.SKIN_BACKGROUND_DARK
        )
        .attr('stroke', d => this.color({ id: d.parentId }))
        .attr('stroke-width', d => (isDotHighlighted(d) ? this.config.highlightedPointStroke : 1))

      this.itemsEnterTrans.select('.break-point').select(`.${className}`).call(drawMergeCb)

      this.itemsTrans
        .select('.break-point')
        .attr(
          'transform',
          (d, i) => {
            let pos = getPos(getValues(d.id, d.value, i))
            return `translate(${pos[0]},${pos[1]})`
          }
          /*
            `translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(
              d.y1 || d.value
            )})`
          */
        )
        .select(`.${className}`)
        .attr(
          'fill',
          !isDarkMode(this.config, this._parent.accessibilityOptions)
            ? COLORS.SKIN_BACKGROUND
            : COLORS.SKIN_BACKGROUND_DARK
        )
        .attr('stroke', d => this.color({ id: d.parentId }))
        .attr('stroke-width', d => (isDotHighlighted(d) ? this.config.highlightedPointStroke : 1))
        .call(drawMergeCb)

      this.itemsExitTrans.select(`.${className}`).attr('opacity', 0)
    }
    const SHAPES_DEFAULT_SIZE = this.config.pointsSize
      ? this.config.pointsSize === 'hidden'
        ? 0
        : this.config.pointsSize
      : 3

    //Circle
    drawShapes(
      'circle',
      'circle',
      sel => drawSvgCircle(sel, 0, 'enter'),
      sel =>
        drawSvgCircle(
          sel,
          d => (isDotHighlighted(d) ? this.config.highlightedPointSize : SHAPES_DEFAULT_SIZE),
          'edit'
        )
    )

    //Square
    drawShapes(
      'square',
      'square',
      sel => drawSvgSquare(sel, 0, 'enter'),
      sel =>
        drawSvgSquare(
          sel,
          d =>
            isDotHighlighted(d) ? this.config.highlightedPointSize * 2 : SHAPES_DEFAULT_SIZE * 2,
          'edit'
        )
    )
    //Triangles
    drawShapes(
      'triangle',
      'triangle',
      sel => drawSvgTriangle(sel, 0, 'enter'),
      sel =>
        drawSvgTriangle(
          sel,
          d =>
            isDotHighlighted(d) ? this.config.highlightedPointSize * 2 : SHAPES_DEFAULT_SIZE * 2,
          'edit'
        )
    )

    //Five point star
    drawShapes(
      'five-point-star',
      'fivePointStar',
      sel => drawSvgStar(sel, 0, 5, 'enter'),
      sel =>
        drawSvgStar(
          sel,
          d =>
            isDotHighlighted(d) ? this.config.highlightedPointSize * 2 : SHAPES_DEFAULT_SIZE * 2,
          5,
          'edit'
        )
    )

    //Six point star
    drawShapes(
      'six-point-star',
      'sixPointStar',
      sel => drawSvgStar(sel, 0, 6, 'enter'),
      sel =>
        drawSvgStar(
          sel,
          d =>
            isDotHighlighted(d) ? this.config.highlightedPointSize * 2 : SHAPES_DEFAULT_SIZE * 2,
          6,
          'edit'
        )
    )

    //Hexagon
    drawShapes(
      'hexagon',
      'hexagon',
      sel => drawSvgPolygon(sel, 0, 6, 'enter'),
      sel =>
        drawSvgPolygon(
          sel,
          d =>
            isDotHighlighted(d) ? this.config.highlightedPointSize * 2 : SHAPES_DEFAULT_SIZE * 2,
          6,
          'edit'
        )
    )

    //Pentagon
    drawShapes(
      'pentagon',
      'pentagon',
      sel => drawSvgPolygon(sel, 0, 5, 'enter'),
      sel => drawSvgPolygon(sel, SHAPES_DEFAULT_SIZE * 2, 5, 'edit')
    )

    //Plus
    drawShapes(
      'plus',
      'plus',
      sel => drawSvgPlus(sel, 0, 'enter'),
      sel => drawSvgPlus(sel, SHAPES_DEFAULT_SIZE * 2, 'edit')
    )
    /*
    breakpointsEnter.append('circle')

    this.itemsEnter
      .select('.break-point')
      .attr('transform', function (d, i) {
        let pos = getPos(getValues(d.id, d.value, i))
        return `translate(${pos[0]},${pos[1]})`
        // return `translate(${self.axes.x.scale(d.id)},${self.axes[dimsIds[i]].scale(d.value)})`
      })
      .select('circle')
      .attr('fill', d =>
        !isDarkMode(this.config, this._parent.accessibilityOptions)
          ? COLORS.SKIN_BACKGROUND
          : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }))
      .attr('r', 0)

    this.itemsEnterTrans
      .select('.break-point')
      .select('circle')
      .attr(
        'fill',
        !isDarkMode(this.config, this._parent.accessibilityOptions)
          ? COLORS.SKIN_BACKGROUND
          : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }))
      .attr('r', 3)

    this.itemsTrans
      .select('.break-point')
      .attr('transform', function (d, i) {
        let pos = getPos(getValues(d.id, d.value, i))
        return `translate(${pos[0]},${pos[1]})`
        // return `translate(${self.axes.x.scale(d.id)},${self.axes[dimsIds[i]].scale(d.value)})`
      })
      .select('circle')
      .attr(
        'fill',
        !isDarkMode(this.config, this._parent.accessibilityOptions)
          ? COLORS.SKIN_BACKGROUND
          : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }))
      .attr('r', 3)

    this.itemsExitTrans.style('opacity', 0)
    if (this.parentItemsExitTrans) this.parentItemsExitTrans.style('opacity', 0)
    */

    //datum values
    let datumValues = this.itemsEnter
      .merge(this.items)
      .select('.break-point')
      .selectAll('.datum-value')
      .data(d => (this.config.showDatumValues ? [d] : []))

    this.itemsExit.select('.datum-value').transition().style('opacity', 0).remove()
    datumValues.exit().transition().style('opacity', 0).remove()

    datumValues = datumValues.merge(
      datumValues
        .enter()
        .append('text')
        .attr('class', 'datum-value')
        .style('opacity', 0)
        .style('font-weight', 'bold')
        .attr('fill', 'currentColor')
    )
    datumValues
      .attr(
        'font-size',
        this._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
          ? '18px'
          : '14px'
      )
      .text(d => {
        let yDims = this.getYAxesIds()
        let yDimNames = this.getYAxesLabels()
        let onAxis = yDims[yDimNames.indexOf(d.id)]
        return this.valueWithUnit(d.value, onAxis)
      })
      .transition()
      .style('opacity', 1)

    const setDatumValueYPosition = selection => {
      const { y: rootY, height: rootHeight } = this.$root.getBoundingClientRect()
      function getYPosition() {
        const { y: datumValueY, height: datumValueHeight } = this.getBoundingClientRect()
        if (datumValueY > rootY + rootHeight / 2) return `${datumValueHeight}px`
        return '-8px'
      }
      selection.attr('y', getYPosition)
    }
    datumValues.attr('text-anchor', 'middle').attr('x', 0)
    datumValues.call(setDatumValueYPosition)

    //(RADAR) AXIS LABELS
    let xDims = this.getXAxesIds()
    let yDims = this.getYAxesIds()
    if (xDims.length === 0) {
      let yDimNames = this.getYAxesLabels()
      let titleRadius = this.axes[yDims[0]].scale.range()[1] + 10
      yDims.forEach((axis, i) => {
        let root = this.axes[axis].selection
        let titles = root.selectAll('.title').data([null])
        let titlesEnter = titles.enter().append('text').attr('class', 'title')
        let angle = (i / yDims.length) * 360
        titles
          .merge(titlesEnter)
          .text(d => yDimNames[i])
          .attr('text-anchor', () => (angle === 0 ? 'middle' : angle > 180 ? 'end' : 'start'))
          .attr('dominant-baseline', 'central')
          .attr('fill', 'currentColor')
          .attr('transform', (d, i) => {
            if (i == 0) return `translate(0,${titleRadius + 14}) rotate(${-angle + 180}) `
            else return `translate(0,${titleRadius}) rotate(${-angle + 180}) `
          })
      })
    }

    //(RADAR) Grid lines
    if (xDims.length === 0) {
      let mainAxis = this.axes['y_0']
      let grids = mainAxis.selection.selectAll('.grid').data(mainAxis.scale.ticks(5))
      let gridsEnter = grids.enter().append('path').attr('class', 'grid').attr('stroke', '#ddd')
      grids.exit().remove()
      grids = grids.merge(gridsEnter)
      let dtheta = (2 * Math.PI) / yDims.length
      grids.attr('d', d => {
        let r = mainAxis.func.scale()(d)
        return (
          `M 0,${r}` +
          yDims
            .map((dim, i) => `L ${Math.sin(dtheta * i) * r} ${Math.cos(dtheta * i) * r}`)
            .join('') +
          'Z'
        )
      })
      let ticksData = [mainAxis.scale.domain()[1]]
      let ticks = mainAxis.selection.selectAll('.my-tick').data(ticksData)
      let ticksEnter = ticks
        .enter()
        .append('text')
        .attr('class', 'my-tick')
        .attr('fill', 'currentColor')
        .attr('text-anchor', 'start')
      ticks
        .merge(ticksEnter)
        .text(d => this.formatValue.bind(this)(d, 'y_0'))
        .attr(
          'font-size',
          this._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
            ? '18px'
            : '14px'
        )
        .attr('dx', 5)
        .attr('transform', d => ` translate(0,${mainAxis.func.scale()(d)}) rotate(${-180})`)
    }
  }
}
